import React from 'react';
import styled from 'styled-components';
import checkicon from 'assets/icons/check.svg';

export function Checkbox({ children, checked, onChange, name, value, label, disabled, ...props }) {
  const onChangeHandler = (e) => {
    const { checked } = e.target;
    onChange(value, name, checked);
  };

  return (
    <Label disabled={disabled} {...props}>
      <CheckboxStyle
        type="checkbox"
        id={label}
        name={name}
        value={value}
        onChange={onChangeHandler}
        checked={checked}
        disabled={disabled}
      />
      {children}
    </Label>
  );
}

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  color: rgba(23, 23, 23, 0.7);
`;

export const CheckboxStyle = styled.input`
  cursor: pointer;
  margin: 0;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 1.5px solid ${({ theme }) => theme.colors.lighter};
  border-radius: 50%;
  background-image: url(${checkicon});
  background-position: center;
  background-repeat: no-repeat;

  &:checked {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.primary};
  }
`;
